<template>
  <div class="c360-link" @click="onClick">
    <v-btn text :height="size" rounded :class="sizeClass">
      <div class="d-flex flex-column text-none text-right c360-link-button-text">
        <p class="mb-1 ">Return to</p>
        <p class="mb-0">Homepage</p>
      </div>
      <slot>
        <v-sheet color="white" :width="size" :height="size" rounded="circle"
          class="d-flex justify-center align-center ml-2">
          <c360-icon icon="Arrow_Undo_Up_Left" :size="iconSize" />
        </v-sheet>
      </slot>
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue';

import { C360Icon } from '../../Icon';

/**
 * A button that links to the portal.
 */
export default Vue.extend({
  name: 'PortalButton',

  components: {
    C360Icon,
  },

  props: {
    /**
     * The link to the portal.
     */
    link: {
      type: String,
      required: true,
    },

    variant: {
      type: String,
      default: 'normal',
    },
  },

  computed: {
    sizeClass() {
      return this.variant === 'small' ? 'c360-link-button-small' : 'c360-link-button-normal';
    },
    size() {
      return this.variant === 'small' ? 44 : 56;
    },
    iconSize() {
      return this.variant === 'small' ? 24 : 28;
    },
  },

  methods: {
    onClick() {
      this.$emit('click', this.link);
    },
  },
});
</script>

<style scoped>
.c360-link-button-normal .c360-link-button-text {
  font-size: 14px;
}

.c360-link-button-small .c360-link-button-text {
  font-size: 12px;
}
</style>
